import React from 'react';
import ShieldIcon from 'assets/icons/shieldCheck.svg?react';
import { convertCentsToDisplayPrice } from 'utils/currency';
import styles from './MinimumGuaranteeBox.module.css';

type MinimumGuaranteeBoxProps = {
    netRevenue: number;
    minimumGuaranteeAmount: number;
    // A single month's guarantee isn't meaningful compared against a multi-month net
    // revenue total, so callers that can span multiple months (e.g. Income Statement's
    // date-range picker) should pass null in that case to hide the box entirely.
    // Callers whose selection is always a single month (e.g. Reports' month picker)
    // can just pass their month label directly.
    monthLabel: string | null;
};

export const MinGuaranteeShieldIcon = () => <ShieldIcon className={styles.minimumGuaranteeShield} />;

function MinimumGuaranteeBox({ netRevenue, minimumGuaranteeAmount, monthLabel }: MinimumGuaranteeBoxProps) {
    if (!monthLabel) return null;

    return (
        <div className={styles.minimumGuaranteeContainer}>
            <p className={styles.minimumGuaranteeTitle}>
                <MinGuaranteeShieldIcon /> AirGarage Minimum Guarantee
            </p>
            <div className={styles.minimumGuaranteeStats}>
                <div>
                    <p className={styles.minimumGuaranteeLabel}>Net Revenue ({monthLabel})</p>
                    <p className={styles.minimumGuaranteeValue}>{convertCentsToDisplayPrice(netRevenue)}</p>
                </div>
                <div>
                    <p className={styles.minimumGuaranteeLabel}>Minimum Guarantee</p>
                    <p className={styles.minimumGuaranteeValue}>{convertCentsToDisplayPrice(minimumGuaranteeAmount)}</p>
                </div>
            </div>
        </div>
    );
}

export default MinimumGuaranteeBox;
